export default __webpack_public_path__ + "static/media/person-search-light.ef0f6c9f.svg";